import { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaMagnifyingGlass, FaServer } from "react-icons/fa6";
import { useHookOdp } from "../../../hooks/useHookOdp";
import { RiErrorWarningFill } from "react-icons/ri";
import { useHookWaTemplateCategory } from "../../../hooks/useHookWaTemplateCategory";

export const SelectWaTemplateCategory = ({
    label,
    value,
    setValue,
    placeholder = "Pilih Kategori",
    searchable = true,
    disabled = false,
    disabledMessage = "Pilih kategori terlebih dahulu",
}) => {
    const { data, loading, error } = useHookWaTemplateCategory();

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const wrapperRef = useRef(null);

    const safeData = Array.isArray(data) ? data : [];

    // Menutup dropdown dan membersihkan search jika klik di luar
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selected = safeData.find((o) => o.id === value);

    const filteredOptions = safeData.filter((o) =>
        o?.name?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="w-full relative" ref={wrapperRef}>
            {label && (
                <label className="block text-xs font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">
                    {label}
                </label>
            )}

            {/* Select Box */}
            <div
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 cursor-pointer transition-all duration-200"
                style={{
                    borderColor: open ? "rgba(0, 180, 216, 0.5)" : "rgba(71, 85, 105, 0.4)",
                    boxShadow: open ? "0 0 0 1px rgba(0, 180, 216, 0.2)" : "none",
                }}
            >
                <div className="flex items-center gap-2 min-w-0 flex-1">
                    {!selected && (
                        <FaServer className="text-slate-500 text-xs flex-shrink-0" />
                    )}
                    <span
                        className={`text-ellipsis truncate ${!selected ? "text-slate-500" : "text-gray-100"
                            }`}
                    >
                        {selected ? selected.name : placeholder}
                    </span>
                </div>
                <FaChevronDown
                    className={`text-xs text-slate-500 flex-shrink-0 ml-2 transition-transform duration-200 ${open ? "rotate-180" : ""
                        }`}
                />
            </div>

            {open && disabled && (
                <div
                    className="absolute z-50 mt-2 w-full rounded-xl overflow-hidden shadow-2xl shadow-black/40"
                    style={{
                        background: "rgba(15, 23, 42, 0.95)",
                        border: "1px solid rgba(51, 65, 85, 0.5)",
                        backdropFilter: "blur(16px)",
                    }}
                >
                    <div
                        className="p-2.5 flex items-center justify-center bg-red-500/30 text-white"
                        style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.3)" }}
                    >
                        <RiErrorWarningFill className="" />
                        <span className="text-xs">{disabledMessage}</span>
                    </div>
                </div>
            )}

            {/* Dropdown Menu */}
            {open && !disabled && (
                <div
                    className="absolute z-50 mt-2 w-full rounded-xl overflow-hidden shadow-2xl shadow-black/40"
                    style={{
                        background: "rgba(15, 23, 42, 0.95)",
                        border: "1px solid rgba(51, 65, 85, 0.5)",
                        backdropFilter: "blur(16px)",
                    }}
                >
                    {/* Input Pencarian */}
                    {searchable && (
                        <div
                            className="p-2.5"
                            style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.3)" }}
                        >
                            <div className="relative">
                                <FaMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs" />
                                <input
                                    type="text"
                                    placeholder="Cari ODP..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 text-sm rounded-lg bg-slate-800/80 border border-slate-600/30 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
                                    autoFocus
                                />
                            </div>
                        </div>
                    )}

                    {/* List Options */}
                    <div className="max-h-56 overflow-y-auto py-1">
                        {/* Validasi ODC ID */}

                        {/* Opsi Reset */}
                        <div
                            onClick={() => {
                                setValue("");
                                setOpen(false);
                                setSearch("");
                            }}
                            className={`px-3 py-2.5 mx-1 rounded-lg cursor-pointer text-sm transition-all duration-150 flex items-center gap-2 ${value === ""
                                ? "bg-cyan-600/15 text-cyan-400 font-semibold"
                                : "text-slate-400 hover:bg-slate-700/40 hover:text-gray-100"
                                }`}
                        >
                            <FaServer className="text-xs flex-shrink-0" />
                            <span>Semua ODP</span>
                        </div>

                        {/* Opsi Data */}
                        {filteredOptions.length === 0 ? (
                            <div className="px-3 py-6 text-center">
                                <p className="text-slate-500 text-sm italic">
                                    ODP tidak ditemukan
                                </p>
                            </div>
                        ) : (
                            filteredOptions.map((opt) => (
                                <div
                                    key={opt.id}
                                    onClick={() => {
                                        setValue(opt.id);
                                        setOpen(false);
                                        setSearch("");
                                    }}
                                    className={`px-3 py-2.5 mx-1 rounded-lg cursor-pointer text-sm transition-all duration-150 flex items-center gap-2 ${value === opt.id
                                        ? "bg-cyan-600/15 text-cyan-400 font-semibold"
                                        : "text-slate-300 hover:bg-slate-700/40 hover:text-gray-100"
                                        }`}
                                >
                                    <FaServer className="text-xs flex-shrink-0 opacity-50" />
                                    <span className="truncate">{opt.name}</span>
                                </div>
                            ))
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};